import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import HeaderAvatarIcon from 'Views/Onboarding/Components/InfoBox/HeaderAvatarIcon';

const styles = theme => ({
  root: {
    padding: theme.spacing(1.5, 3),
    backgroundColor: theme.palette.facet.backgroundGray,
    borderRadius: theme.radius.md,
    position: 'relative',
  },
  headerIcon: {
    position: 'absolute',
    top: 0,
    left: '50%',
    transform: 'translate(-50%, -50%)', // Move up by  half its height and left by half its width
  },
  rootWithIcon: {
    paddingTop: theme.spacing(6),
  },
});

const InfoBox = ({
  className,
  classes,
  children,
  icon,
}) => {
  return (
    <Box
      className={classNames(classes.root, className, icon && classes.rootWithIcon)}
    >
      {icon ? (
        <HeaderAvatarIcon
          icon={icon}
          className={classes.headerIcon}
        />
      ) : null}
      {children}
    </Box>
  );
};

InfoBox.defaultProps = {
  className: '',
  icon: null,
};

InfoBox.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};

export default withStyles(styles)(InfoBox);
